import { ChartColumnIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/card';

export function Statistics() {
	const { t } = useTranslation();
	return (
		<div className="flex-1 overflow-auto p-6 m-0">
			<Card className="py-0 shadow-sm">
				<CardContent className="p-6 pt-6 flex flex-col items-center justify-center">
					<ChartColumnIcon className="size-12 text-muted-foreground mb-2" />
					<p className="text-sm text-muted-foreground font-medium">{t('health.charts.placeholderStatisticsTitle')}</p>
					<p className="text-xs text-muted-foreground mt-1 text-center max-w-xs px-4">
						{t('health.charts.placeholderSubtitle')}
					</p>
				</CardContent>
			</Card>
		</div>
	);
}
